export default "__VITE_ASSET__BLc070aU__"